import React from 'react';
import Heading from '../../../components/controls/Typography/Heading';
import useRecommendation from '../../../utils/useRecommendation';

export const PatientDiagnoses = () => {
  const recommendation = useRecommendation();
  const observationHoursDataEval = recommendation.item?.observationHoursDataEval;

  return (
    <div className="lsn-observation-group lsn-observation-PT-Diagnoses">
      <Heading bold level={3} tabIndex={0} asSpan className='lsn-obs-recommendation-form-header lsn-observation-font-header'>PT Patient Diagnoses/Populations Observed:</Heading>
      <ul className="lsn-obs-patient-checklist columns">
        {observationHoursDataEval?.patientDiagnosesTypes
          ? observationHoursDataEval?.patientDiagnosesTypes.map((patient, idx) => (
            <li className="lsn-obs-patient-checklistLi column col-6 col-md-12" key={idx}>
              {patient.selected === true ? (
                <>
                  <i className="fa fa-check color-primary lsn-obs-patient-checklist-test" />
                  <span className="lsn-observation-check-mark">{patient.text}</span>
                </>
              ) : (
                <span className="lsn-observation-check-mark-not">{patient.text}</span>
              )}
            </li>
          ))
          : []}
      </ul>
    </div>
  );
}

export default PatientDiagnoses;
